/**
 * Handles when the loading dialog is shown.
 */
Drupal.behaviors.toybox_step_form_loading = {
  attach: function (context) {
    const form = context.querySelector(".js-bupl-form-step");
    const loadingDialog = context.querySelector(".js-dialog-loading");
    const loadingDialogExtended = context.querySelector(
      ".js-dialog-extended-loading",
    );

    // Check if the required elements are present
    if (!loadingDialog || !loadingDialogExtended || !form) {
      return;
    }

    function handleLoadingState() {
      loadingDialog.classList.remove("is-hidden");
      loadingDialog.setAttribute("aria-hidden", "false");

      // If loading takes a while, show the loading dialog with text.
      setTimeout(() => {
        loadingDialog.classList.add("is-hidden");
        loadingDialog.setAttribute("aria-hidden", "true");

        loadingDialogExtended.classList.remove("is-hidden");
        loadingDialogExtended.setAttribute("aria-hidden", "false");
      }, 5000);
    }

    // Show the loading dialog when the form is submitted
    form.addEventListener("submit", handleLoadingState);
  },
};
